import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaIcon } from '../../FaIcon';
import { PERIODS } from '../pricingConfig';
import { MCP_PLANS } from './mcpPricingConfig';
import { McpUpgradePlanCard } from './McpUpgradePlanCard';

const PERIOD_OPTIONS = [
    { id: 'yearly', labelKey: 'upgrade_to_dashbo.pricing.yearly' },
    { id: 'semestral', labelKey: 'upgrade_to_dashbo.pricing.semestral' },
    { id: 'trimestral', labelKey: 'upgrade_to_dashbo.pricing.trimestral' },
    { id: 'monthly', labelKey: 'upgrade_to_dashbo.pricing.monthly' },
];

export function McpUpgradePricingSection() {
    const { t } = useTranslation();
    const [currency, setCurrency] = useState('USD');
    const [period, setPeriod] = useState('yearly');

    const handleFooterClick = (e) => {
        e.preventDefault();
        const message = t('mcp_upgrade.pricing.intercom_custom_message');
        if (typeof window.Intercom === 'function') {
            window.Intercom('showNewMessage', message);
        }
    };

    return (
        <div className="upgrade-pricing">
            <h2 className="upgrade-section-title">{t('mcp_upgrade.pricing.section_title')}</h2>
            <p className="upgrade-section-subtitle">{t('mcp_upgrade.pricing.section_subtitle')}</p>

            <div className="pricing-toggles">
                <div className="toggle-group currency-toggle">
                    <button
                        className={`toggle-btn ${currency === 'USD' ? '-active' : ''}`}
                        onClick={() => setCurrency('USD')}
                    >USD</button>
                    <button
                        className={`toggle-btn ${currency === 'ARS' ? '-active' : ''}`}
                        onClick={() => setCurrency('ARS')}
                    >ARS</button>
                </div>
                <div className="toggle-group period-toggle">
                    {PERIOD_OPTIONS.map((opt) => {
                        const discount = PERIODS[opt.id].discount;
                        return (
                            <button
                                key={opt.id}
                                className={`toggle-btn ${period === opt.id ? '-active' : ''}`}
                                onClick={() => setPeriod(opt.id)}
                            >
                                {t(opt.labelKey)}
                                {discount > 0 && <span className="discount-tag">-{discount}%</span>}
                            </button>
                        );
                    })}
                </div>
            </div>

            {currency === 'ARS' && (
                <p className="pricing-ars-note">{t('upgrade_to_dashbo.pricing.ars_note')}</p>
            )}

            <div className="mcp-pricing-grid">
                {MCP_PLANS.map((plan) => (
                    <McpUpgradePlanCard
                        key={plan.id}
                        plan={plan}
                        currency={currency}
                        period={period}
                    />
                ))}
            </div>

            <div className="mcp-pricing-footer">
                <span>{t('mcp_upgrade.pricing.footer_text')}</span>
                <button type="button" className="btn -alt -negative mcp-pricing-footer-cta" onClick={handleFooterClick}>
                    <FaIcon iconName="comments" />
                    {t('mcp_upgrade.pricing.footer_cta')}
                </button>
            </div>
        </div>
    );
}
